export const environment = {
  production: true,
  urlOpenBanking: "https://openbanking.financiamentos.bradesco/Openbanking/Gestao/?SessionID=",
  urlSite: "https://wwwsn.bradescofinanciamentos.com.br",
  chavePublica: "/bfportalcli/assets/key/fi-chave-publica.xml",
 // chavePrivada: "/bfportalcli/assets/key/fi-chave-privada.xml"
};



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/environments/environment.ts